import { render } from "./AdminEntityLink.vue?vue&type=template&id=f8cede8e"
import script from "./AdminEntityLink.vue?vue&type=script&lang=js"
export * from "./AdminEntityLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__